import { createWebSocketStore } from 'src/components/#services/helpers';
export const requestToDeleteAccount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'auth_sendRequestToDeleteAccount',
        agent: 'auth',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const isAvailablePurchases = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'authJournal_checkIsAvailableCountry',
        agent: 'auth',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const confirmIPByCode = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'auth_confirmIPByCode',
        agent: 'auth',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
